export function isVideoFile(file: File) {
  return file.type.indexOf('video') > -1;
}
